export class CartItem {
	public articleId: number = 0;
	public quantity: number = 0;
}
